// extracted by mini-css-extract-plugin
export var title = "styles-module--title--5608b";
export var wrapper = "styles-module--wrapper--f0cf5";